export const ASSOCIATE_PROMPT = 'contactPrompt';
export const CREATE_TICKET_PROMPT = 'ticketPrompt';
export const DISASSOCIATE_PROMPT = 'disassociatePrompt';
export const BLOCK_THREAD_PROMPT = 'blockThreadPrompt';